.methodContainer {
	display: flex;
	flex-direction: column;
	gap: 0.625rem;
	height: 100%;
	width: 100%;
}

.methodGrid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	column-gap: 1rem;
	row-gap: 1rem;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	padding: 0.5rem;
}

/* If there are only 1 or 2 buttons, make it 2x1 grid */
.methodGrid:has(> *:nth-child(-n + 2):last-child) {
	grid-template-columns: 1fr;
}

/* Make the first button span 2 columns if there is 3 buttons */
.methodGrid > *:first-child:nth-last-child(3) {
	grid-column: 1 / -1;
}

.methodButton:global(.MuiButton-root) {
	padding: 1rem 1.375rem 0.5rem 1.375rem;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	align-items: flex-start;
	justify-content: center;
	width: 100%;
	height: 100%;
	gap: 0.75rem;
}

.badgeRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 0.3125rem;
	align-items: center;
	width: 100%;

	.methodBadge {
		border-radius: 6px;
		height: 26px;
		min-height: fit-content;
		padding: 0 10px;
	}

	.methodBadge span {
		color: #7b1fa2;
		font-size: 0.75rem;
		line-height: 1.6;
		font-weight: 500;
		letter-spacing: 0;
		padding: 0;
	}
}

.methodColumn {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
	align-items: center;
	justify-content: center;
	width: 100%;
	flex: 1;

	.methodName:global(.MuiTypography-root) {
		color: #101828;
		font-weight: 600;
		font-size: 1rem;
		line-height: 24px;
		letter-spacing: -0.31px;
	}

	.methodDescription:global(.MuiTypography-root) {
		color: #6b6b6b;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
		letter-spacing: -0.15px;
		text-align: center;
	}

	& svg {
		height: 32px !important;
		width: 32px !important;
	}
}

@media (max-width: 768px) {
	.methodContainer {
		padding: 0.625rem;
	}
	.methodGrid {
		grid-template-columns: 1fr !important;
	}
}
